import { TrackedEvents, trackEvent } from 'analytics';
import { useNavigate } from 'react-router-dom';
import { Box, ExpandableIconButton, HeroMediaGrid, ImageCarousel, Link, useBreakpoint } from 'ui';
import { ImageOutlined } from 'ui/icons';

import { GuidePriceChip } from '../../../guide-price';
import type { QualityReportTrackingSource } from '../../../types';
import { QualityReportSummary } from '../QualityReportSummary/QualityReportSummary';

export const SiteMaterialQualityReportHeader = ({
  originCountry,
  material,
  grade,
  availableTonnage,
  estimatedDeliveryDate,
  tonnesPerLoad,
  photoEvidence,
  placeholderSrc,
  guidePrice,
  deliveryLocation,
  source,
}: {
  originCountry?: string;
  material: string;
  grade: string;
  availableTonnage?: string;
  estimatedDeliveryDate?: string;
  tonnesPerLoad?: string;
  photoEvidence: string[];
  placeholderSrc?: string;
  guidePrice?: string;
  deliveryLocation?: string;
  source: QualityReportTrackingSource;
}) => {
  const { isMobile } = useBreakpoint();
  const navigate = useNavigate();

  const handleClickHeader = () => {
    trackEvent(TrackedEvents.QUALITY_REPORT_CLICK_HEADER_IMAGE, {
      source,
    });
    navigate('media');
  };

  const handleClickShowAllMedia = () => {
    trackEvent(TrackedEvents.QUALITY_REPORT_CLICK_SHOW_ALL_MEDIA, {
      source,
    });
    navigate('media');
  };

  return (
    <Box margin={isMobile ? 0 : -3}>
      <Link onClick={handleClickHeader} sx={{ cursor: 'pointer' }}>
        <Box position="relative">
          {photoEvidence && isMobile ? (
            <ImageCarousel
              photoEvidence={photoEvidence}
              showImageCounterOverlay={true}
              slotProps={{
                mediaItem: {
                  alt: 'Evidence photo',
                  omitPadding: true,
                  placeholderSrc: placeholderSrc,
                },
              }}
            />
          ) : (
            <HeroMediaGrid photoEvidence={photoEvidence} placeholderSrc={placeholderSrc} alt="Evidence photo" />
          )}
          <ExpandableIconButton
            icon={<ImageOutlined />}
            label="Show all media"
            onClick={handleClickShowAllMedia}
            sx={{
              margin: 2,
              position: 'absolute',
              right: 0,
              top: 20,
            }}
          />
        </Box>
      </Link>

      <Box paddingX={2} position="relative">
        {guidePrice ? (
          <Box
            sx={(theme) => ({
              left: theme.spacing(2),
              position: 'absolute',
              top: isMobile ? '-160px' : '-120px',
            })}
          >
            <GuidePriceChip size="large" guidePrice={guidePrice} />
          </Box>
        ) : null}

        <QualityReportSummary
          originCountry={originCountry}
          material={material}
          grade={grade}
          availableTonnage={availableTonnage}
          estimatedDeliveryDate={estimatedDeliveryDate}
          tonnesPerLoad={tonnesPerLoad}
          deliveryLocation={deliveryLocation}
        />
      </Box>
    </Box>
  );
};
